<template>
  <tariff-buy v-if="!isFetching"
    :onCreatePayment="createPayment" 
    :onBuyTariff="buyTariff"
    :tariff="viewedTariff" 
    :hasTariff="hasTariff" 
    :products="products"
    :is-filled="isFilled" 
    :is-identified="isIdentified"
    :balance="balance" />
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { requestFund, buy } from "../../../services/api/finance";
import TariffBuy from "./TariffBuy.vue";

export default {
  name: "tariff-buy-container",
  components: {
    TariffBuy
  },
  created() {
    if (!this.isFetching) {
      this.isFetching = true;
      this.fetchTariffs()
        .then(res => {
          this.fetchProfile()
            .then((res) => {
              this.isFetching = false;
            })
            .catch((res) => {
              this.isFetching = false;
            });
        })
        .catch(res => {
          this.isFetching = false;
        });
    }
  },
  data() {
    return {
      isFetching: false
    };
  },
  methods: {
    ...mapActions(["error"]),
    ...mapActions("paymentHistory", ["addRecord"]),
    ...mapActions("tariff", ["fetchTariffs"]),
    ...mapActions("notification", ["show"]),
    ...mapActions('profile', ['fetchProfile']),

    createPayment(values) {
      return requestFund(values)
        .then(res => {
          this.addRecord(res.data);
          if (res.data.link) {
            window.location.href = res.data.link;
          }else{
            window.open(`/api/v1/finance/fundHistory/pdf?id=${res.data.id}`, '_blank');
          }
          return res;
        })
        .catch(res => {
          this.error(res);

          return Promise.reject(res);
        });
    },
    buyTariff(id){
      return buy(id);
    }
  },
  computed: {
    ...mapState("contract", ["additional"]),
    ...mapState("profileTariff", ["tariff"]),
    ...mapGetters("tariff", ["objectTariffs"]),
    ...mapGetters('profile', ['isFilled', 'isIdentified', 'balance']),

    viewedTariff() {
      return this.objectTariffs[this.$route.params.tariff];
    },

    products() {
      return this.viewedTariff && this.viewedTariff.products;
    },

    hasTariff() {
      return Boolean(this.tariff && this.tariff.title);
    },
  }
};
</script>



// WEBPACK FOOTER //
// TariffBuyContainer.vue?28122015